export const rgbToColor = (rgbObject) => `rgb(${rgbObject.r}, ${rgbObject.g}, ${rgbObject.b})`;